import { INTERNAL_SUPPLIER } from "@hisense/shared";

/**
 * Nhà cung cấp riêng tư người xem không được thấy (anh Toàn chốt 28/10/2026): máy chủ thay tên bằng `INTERNAL_SUPPLIER` ở mọi phản
 * hồi; ở đây dịch nhãn đó thành "Nhà cung cấp nội bộ" theo ngôn ngữ đang dùng — MỘT cửa (`apiFetch`) thay vì từng màn hình (81 chỗ
 * hiện tên nhà cung cấp, cả bản in và tệp xuất dựng từ chính dữ liệu này).
 *
 * Lưu ngược một chứng từ đã che là gửi lại đúng chữ đã dịch — máy chủ từ chối (`private_supplier`), nên tên thật không bị ghi đè.
 */
export function translateInternalSupplier<T>(value: T, label: string): T {
  return walk(value, label) as T;
}

function walk(value: unknown, label: string): unknown {
  if (value === INTERNAL_SUPPLIER) return label;
  if (Array.isArray(value)) return value.map((v) => walk(v, label));
  if (!value || typeof value !== "object") return value;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) out[k] = walk(v, label);
  return out;
}
